/*
Sohel 01/08/2023 2701335619 Implemented Usage Functionality
Sohel 01/08/2023 2701335619 Fixed Download Usage Configuration Issue
Ravi 02/09/2023 2701335619 changed title from from framework to Data Management
Raghu 02/27/2023 2701335619 fixed ui alignments
Akhila 06/08/2023 2701335619 title label placeholder name change
Akhila 06/09/2023 2701335619 change usage detail heading
Sohel 12/12/2023 2701335619 column name change code to name 
*/
import React, {useEffect, useContext, useState} from 'react';
import capitalize from '../../../../../util/Capitalize';
import {useSelector, useDispatch} from 'react-redux';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import {Button, TablePagination} from '@material-ui/core';
import {ThemeContext} from './../../../../../themes/ThemeProvider';
import {postPrintUsage, resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {ArrowBack} from '@material-ui/icons';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import {resetDataManagerRecordUsageData} from '../../../../../redux/reducers/DataManagerRecord';
import {modulesText} from '../../../../../util/Content';

function DataManagerRecordUsage({dataManagerRecordData, setValue, exportManagerRecord}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {basicInfoSuccessMsg, basicInfoErrorMsg, isBasicInfoLoading, dataManagerRecordUsage} =
    useSelector(({dataManagerRecord}) => dataManagerRecord);
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch(resetDataManagerRecordUsageData());
    };
  }, []);

  const [rows, setRows] = useState(defaultRows);
  const moduleType = exportManagerRecord ? 'Export' : 'Import';
  const usageType = exportManagerRecord ? 'EXPORT TEMPLATE RECORD' : 'IMPORT TEMPLATE RECORD';
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);

  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);

  const object = dataManagerRecordUsage?.placeResponse ? dataManagerRecordUsage?.placeResponse : {};

  const values = [];
  object &&
    Object.entries(object)?.forEach(([key, value]) => {
      value?.length > 0 &&
        value?.forEach((el, i) => {
          values.push({
            frameWork: key,
            codes: el?.code,
            description: el?.description ?? '',
          });
        });
    });
  const columns = [
    {
      title: modulesText,
      field: 'frameWork',
      render: (rowData) => {
        return rowData?.frameWork ? capitalize(rowData?.frameWork) : '--';
      },
    },
    {
      title: 'Name',
      field: 'codes',
      render: (rowData) => {
        return rowData?.codes ? rowData?.codes : '--';
      },
    },
    {
      title: 'Description',
      field: 'description',
      render: (rowData) => {
        return rowData?.description ? rowData?.description : '--';
      },
    },
  ];
  return (
    <div className="new-standard-textfields">
      <div className={` mb-0`}>
        <div className="button-table-spacing-mb justify-content-start">
          <Button
            variant="outlined"
            type="button"
            className={`search-btn mx-1`}
            onClick={() => {
              setValue(0);
            }}
          >
            <ArrowBack className="mr-2" />
            Back To Search
          </Button>
        </div>
        <div className="custom-table custom-toolbar-icons global-field-table">
          <GuiTable
            title={`${dataManagerRecordData?.recordCode} - ${dataManagerRecordData?.recordDescription} This ${moduleType} Template Record has been used in the following 
            places.`}
            columns={columns}
            data={values}
            textAlign="left"
            options={{
              paging: true,
              toolbar: true,
              search: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
              pageSize: rows,
              pageSizeOptions: tablePageRows,
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <div className="mt-2">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn ${classes.buttonRoot}`}
                      color="primary"
                      disabled={dataManagerRecordUsage.userMetrix === 'No'}
                      onClick={(event) => {
                        dispatch(
                          postPrintUsage({
                            baseCategory: '',
                            code: '',
                            description: '',
                            displayName: '',
                            fileType: '',
                            recordFormatType: '',
                            returnType: '',
                            sourceType: usageType,
                            isDraft: '',
                            masterRecord: dataManagerRecordData?.masterRecord ?
                              dataManagerRecordData?.masterRecord :
                              '',
                            search: '',
                            frameworkUsageOrderBy: '',
                            frameworkUsageOrderDerection: '',
                            fieldListOrderBy: '',
                            fieldListOrderDerection: '',
                            category: dataManagerRecordData?.category ?
                              dataManagerRecordData?.category :
                              '',
                            fieldName: '',
                            repositoryDescription: '',
                            repositoryName: '',
                            repositoryType: '',
                            createdBy: '',
                            recordCode: dataManagerRecordData?.recordCode ?
                              dataManagerRecordData?.recordCode :
                              '',
                            recordType: dataManagerRecordData?.recordType ?
                              dataManagerRecordData?.recordType :
                              '',
                            recordDescription: dataManagerRecordData?.recordDescription ?
                              dataManagerRecordData?.recordDescription :
                              '',
                            createdDate: '',
                            includeAudit: dataManagerRecordData?.includeAudit ?
                              dataManagerRecordData?.includeAudit :
                              '',
                          }),
                        );
                      }}
                    >
                      Download Configuration Usage
                    </Button>
                  </div>
                  <div className="w-50" style={{backgroundColor: 'white', border: '0px'}}>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </div>
      {(isBasicInfoLoading || printUsageIsLoading) && <PageLoader />}
      {(basicInfoErrorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={basicInfoErrorMsg || printUsageErrorMsg} />
      )}
      {(basicInfoSuccessMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar successMsg={basicInfoSuccessMsg || printUsageSuccessMsg} />
      )}
    </div>
  );
}

export default DataManagerRecordUsage;
